import React from "react";

export default function TabButton({ label, active, onClick }) {
    return (
        <button
            onClick={onClick}
            className={`relative flex items-center justify-center gap-1 sm:gap-2 md:gap-3 px-2 sm:px-3 md:px-4 lg:px-6 py-2 md:py-3 rounded-xl transition-all duration-200 flex-1 min-w-0 ${
                active
                    ? "bg-orange-500 text-white"
                    : "text-gray-600 hover:bg-slate-300"
            }`}
        >
            <span className="font-medium text-xs sm:text-sm truncate">
                {label}
            </span>
        </button>
    );
}
